<template>
  <div id="container">
    <v-container
      fluid
      class="white lighten-5"
      style="padding-left: 3%; padding-right: 3%"
    >
      <div class="d-flex align-items-center">
        <v-card
          class="mx-auto rounded-lg elevation-4 ma-3 w-100"
          outlined
          :style="'border: 4px solid black; background-color:transparent;'"
        >
          <v-list-item-content>
            <div class="text-general-module mb-0">
              <v-icon color="black" @click="videoShow"
                >mdi-ballot-recount-outline</v-icon
              >
              <span>&nbsp;MOVIMIENTOS DE CUENTA </span>
            </div>
          </v-list-item-content>
        </v-card>
      </div>
      <div class="notice-container">
        <div class="notice-md">
          **Si requiere imprimir sus recibos es desde el botón "Recibos de
          pago"**
        </div>
      </div>

      <div>
        <data-customer
          class="mt-5"
          :data-client="dataClient"
          :loader="loader"
        ></data-customer>
      </div>
      <v-col md="12" class="mt-2 mb-0">
        <v-row>
          <v-col cols="12" sm="6" md="2" lg="2">
            <v-btn
              depressed
              block
              class="button-red-small text-white font-weight-bold font-size-8"
              @click="isAccountStatementRecordOpen = true"
            >
              <span class="text-wrap">Histórico Estado de cuenta</span>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="2" lg="2">
            <v-btn
              depressed
              block
              class="button-red-small text-white font-weight-bold font-size-8"
              @click="isPaymentHistoryModalOpen = true"
            >
              <span class="text-wrap">Historial de Pagos</span>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="2" lg="2">
            <v-btn
              depressed
              block
              class="button-red-small text-white font-weight-bold font-size-8"
              @click="isPaymentReceiptModalOpen = true"
            >
              Recibo de Pagos
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="2" lg="2">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn
                  v-if="hasDiscountParam == 0"
                  depressed
                  block
                  v-bind="attrs"
                  :class="
                    !$hasAnyRole(['Customer', 'CustomerPR'])
                      ? 'button-green-small-disabled '
                      : 'button-green-small'
                  "
                  :disabled="!$hasAnyRole(['Customer', 'CustomerPR'])"
                  v-on="on"
                  @click.prevent="toAntPay"
                >
                  <span class="text-white font-weight-bold text-wrap"
                    >Anticipo c/ factura</span
                  >
                </v-btn>
              </template>
              <span>
                Si usted paga en esta opción, se generará factura por el
                anticipo. <br />
                En este apartado no se hacen pagos de facturas de materiales, ni
                pagos parciales, solo pagos por Anticipo.
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" sm="6" md="1">
            <v-btn
              v-if="hasDiscountParam == 0"
              depressed
              block
              :disabled="payDisableButton"
              :class="
                payDisableButton
                  ? 'button-green-small-disabled '
                  : 'button-green-small'
              "
              @click="toPay"
            >
              <span class="text-white font-weight-bold">Pagar</span>
            </v-btn>
          </v-col>

          <v-col cols="12" md="3">
            <v-row v-if="bonoShow">
              <v-col cols="12" md="6">
                <v-btn
                  depressed
                  color="info"
                  block
                  :disabled="bonusDisableButton"
                  :loading="isSubmitted"
                  :class="
                    bonusDisableButton
                      ? 'button-blue-small-disabled'
                      : 'button-blue-small'
                  "
                  @click.prevent="bondCard"
                  ><span class="text-white font-weight-bold"
                    >Aplicar Bono</span
                  ></v-btn
                >
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="bondCurrent"
                  solo
                  small
                  dense
                  hide-details
                  label="Selecciona Bono"
                  :items="bonusFiltered"
                  item-text="name"
                  item-value="id"
                  @click="validateSelectedInvoice"
                >
                  <template #item="{ on, item }">
                    <v-list-item v-on="on">{{ item.name }}</v-list-item>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <div>
        <v-col md="12" class="mb-0 ml-0">
          <v-row class="mt-0 mr-0" justify="end">
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-btn
                class="btn-multipago blue-button"
                :disabled="downloading"
                @click="downloadPdfReport"
              >
                {{
                  !downloading
                    ? 'Descargar Movimientos de cuenta'
                    : 'Descargando...'
                }}
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="2" lg="2" justify="end">
              <search-input v-model="searchAccounntStatus" />
            </v-col>
          </v-row>
        </v-col>
        <v-card
          class="elevation-0 mt-0"
          :style="'background-color:transparent;'"
        >
          <v-progress-linear
            :active="loadingBono"
            :indeterminate="loadingBono"
            top
            color="deep-purple accent-4"
          ></v-progress-linear>
          <account-movements-table
            v-model="selected"
            :search="searchAccounntStatus"
            :items="discountValidatedFiltered"
          />
        </v-card>
      </div>
      <confidentiality-notice class="mt-10" />
    </v-container>
    <v-dialog v-model="dialog" width="500" persistent>
      <bank-payment-card
        :user-channel="user.VTWEG"
        :customer-code="customerCode"
        :invoice="invoice"
        :type-pay="typePay"
        @close="close"
      />
    </v-dialog>

    <account-status-card
      v-model="isAccountStatementRecordOpen"
      :customer-code="customerCode"
      :customer-group="customerGroup"
    />

    <bonus-modal
      v-model="showBondsModal"
      :selected-invoice="invoice"
      :bonds="bonds"
      :type="bondCurrent"
      :loading="isSubmitted"
      @amount="setBondPaymentAmount"
      @disabled="disabledButtonBond"
      @format="unformatNumber"
      @applyBond="toBond"
    />

    <payment-history
      v-model="isPaymentHistoryModalOpen"
      :customer-code="customerCode"
    />
    <payment-receipt
      v-model="isPaymentReceiptModalOpen"
      :customer-code="customerCode"
    />

    <v-dialog v-model="dialogVideo" width="50%">
      <video-card @closeModa="closeModalVideo" />
    </v-dialog>
  </div>
</template>
<script>
  import axios from '@/plugins/axios';
  import { mapGetters, mapActions } from 'vuex';
  import AccountStatusCard from '../../components/AccountStatusCard.vue';
  import BankPaymentCard from '../../components/BankPaymentCard.vue';
  import SearchInput from '@/components/SearchInput.vue';
  import BonusModal from './components/BonusModal.vue';
  import ConfidentialityNotice from '@/components/ConfidentialityNotice.vue';
  import VideoCard from './components/VideoCard.vue';
  import DataCustomer from '@/components/DataCustomer.vue';
  import numbersFormats from '@/mixins/numbersFormats';
  import { MAX_INVOICES_PER_PAYMENT } from '@/core/constants/PaymentConstants';
  import PaymentHistory from './components/PaymentHistoryModal.vue';
  import PaymentReceipt from './components/PaymentReceiptModal.vue';
  import AccountMovementsTable from './components/AccountMovementsTable.vue';
  import saveFile from '@/mixins/saveFile';
  import dateFormats from '@/core/constants/DateFormats';

  import dates from '@/mixins/dates';

  import moment from 'moment';
  import 'jspdf-autotable';

  export default {
    components: {
      AccountStatusCard,
      BankPaymentCard,
      SearchInput,
      BonusModal,
      ConfidentialityNotice,
      VideoCard,
      DataCustomer,
      PaymentHistory,
      PaymentReceipt,
      AccountMovementsTable,
    },
    mixins: [numbersFormats, dates, saveFile],
    data() {
      return {
        downloading: false,
        loadingBono: false,
        bank: 0,
        dialog: false,
        dialogVideo: false,
        selected: [],
        bondCurrent: null,
        bonds: [],
        bondCost: 0,
        invoice: [],
        dataMovemets: [],
        search: '',
        datacustumer: null,
        token: null,
        today2: moment().format('YYYY/MM/DD'),
        bonoShow: false,
        customerCode: 0,
        customerInfo: [],
        itemCSV: [],
        customerGroup: '',
        typePay: null,
        searchAccounntStatus: '',
        orverdueInvoices: false,
        showBondsModal: false,
        dataClient: {},
        loader: true,
        isSubmitted: false,
        isPaymentHistoryModalOpen: false,
        isPaymentReceiptModalOpen: false,
        isAccountStatementRecordOpen: false,
        dateCurrent: moment().format('D [de] MMMM [del] YYYY HH:mm:ss a'),
      };
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
      hasDiscountParam() {
        return this.$route.params.disc == 'PSPO' ||
          this.$route.params.disc == 'PSPP' ||
          this.$route.params.disc == 'BR'
          ? this.$route.params.disc
          : 0;
      },
      discountValidatedFiltered() {
        return this.dataMovemets.filter((r) => {
          const rebateBonus = r.auart != 'PSPO' && r.auart != 'PSPP';
          const popBonus = this.hasDiscountParam && r.auart == 'PSPP';
          if (
            this.hasDiscountParam == 'PSPO' ||
            this.hasDiscountParam == 'PSPP'
          )
            return r.auart != popBonus;
          if (this.hasDiscountParam == 'BR') return rebateBonus;
          return true;
        });
      },
      rebateDiscount() {
        return this.invoice.every(
          (item) => item.auart != 'PSPO' || item.auart != 'PSPP'
        );
      },
      bonusFiltered() {
        const popDiscount = this.invoice.every(
          (item) => item.auart === 'PSPO' || item.auart === 'PSPP'
        );

        if (this.hasDiscountParam == 0 && this.selected.length == 0) {
          return this.bonds;
        } else if (
          (popDiscount &&
            this.selected.length != 0 &&
            this.hasDiscountParam == 0) ||
          (popDiscount && this.hasDiscountParam == 'PSPO') ||
          (popDiscount && this.hasDiscountParam == 'PSPP')
        ) {
          return this.bonds.filter((r) => r.id == 262);
        } else if (
          (this.rebateDiscount &&
            this.selected.length <= 1 &&
            this.hasDiscountParam == 0) ||
          (this.hasDiscountParam == 'BR' && this.selected.length <= 1)
        ) {
          return this.bonds.filter((r) => r.id == '2RC');
        }

        return [];
      },
      invoiceStatus() {
        return this.dataMovemets.some(
          (item) => item.status == 'Vencido' || item.status == 'VENCIDO'
        );
      },
      bonusDisableButton() {
        if (this.bonusFiltered == '') return true;
        if (
          !this.bondCurrent ||
          this.selected.length == 0 ||
          this.isSubmitted ||
          this.invoiceStatus ||
          !this.$hasAnyRole(['Customer', 'CustomerPR', 'Superuser'])
        )
          return true;
        return false;
      },
      payDisableButton() {
        if (
          this.selected.length == 0 ||
          this.selected.length > MAX_INVOICES_PER_PAYMENT ||
          !this.$hasAnyRole(['Customer', 'CustomerPR', 'Superuser'])
        )
          return true;
        return false;
      },
    },
    watch: {
      selected(value) {
        if (value[0].showSelect) {
          this.$swal({
            title: 'NO SE PUEDE SELECCIONAR ESTA FACTURA',
            icon: 'error',
            type: 'danger',
          });
          return false;
        }

        if (value.length > MAX_INVOICES_PER_PAYMENT) {
          value.pop();
          this.$swal({
            title:
              'Has alcanzado el límite de facturas permitidas por pago. Si necesitas pagar más facturas, realiza otro pago.',
            icon: 'error',
            type: 'danger',
            confirmButtonText: 'CONTINUAR',
            confirmButtonColor: '#A82222',
            closeOnConfirm: true,
          });
          return false;
        }

        this.bondCurrent = '';
        this.invoice = [];
        for (let i = 0; i < value.length; i++) {
          this.invoice.push({
            number: value[i].number,
            amount: value[i].impfacnet,
            difbudat: value[i].difbudatp,
            vbelnnc: value[i].vbelnnc,
            belnrdz: value[i].belnrdz,
            auart: value[i].auart,
            status: value[i].status,
            amountWithoutIva: value[i].impfacnetsi,
            difbudatnet: value[i].difbudat,
            dmbtrdz: value[i].dmbtrdz,
            dmbtr: value[i].amount,
            vbelnnc_s: value[i].vbelnnc_s,
            augru_auft_s: value[i].augru_auft_s,
            impnc_s: value[i].impnc_s,
            budat: moment(value[i].date, dateFormats.DISPLAY_DATE).format(
              dateFormats.ISO_DATE_SLASHED
            ),
          });
        }
      },
      dataMovemets: {
        immediate: true,
        handler() {
          this.generarExcel();
        },
      },
      dataClient() {
        this.generarExcel();
      },
    },
    mounted() {
      if (this.$hasAnyRole(['Customer', 'CustomerPR'])) {
        this.customerCode = this.user.custumer_code;
        this.type = 'CL';
        this.numero_vendedor = this.user.custumer_code;
        this.pathHome = '/';
        this.datacustumer = this.customerInfo;
      } else {
        const currentCustomerInfo =
          JSON.parse(localStorage.getItem('currentCustomerInfo')) || [];
        if (currentCustomerInfo.length < 1) {
          this.$router.push({ name: 'Home' });
        }
        this.customerInfo = currentCustomerInfo;
        this.customerCode = parseInt(currentCustomerInfo?.KUNNR, 10);
        this.datacustumer = this.customerInfo;
        this.sellerOrderAviable = false;
        this.type = 'VE';
        this.numero_vendedor = this.user.employee_number;
        this.pathHome = 'CustomerCoverDetails';
      }

      this.generarPDF();
      this.getCustomerInformation();
      this.getBonds();
      this.getDataClient();

      var token = this.$route.query.token;
      if (token != '') {
        this.getParam1();
      }

      var nbResponse = this.$route.query.nbResponse;
      var cdResponse = this.$route.query.cdResponse;
      var nb_error = this.$route.query.nb_error;
      if (nbResponse != '') {
        this.getParam2(nbResponse, cdResponse, nb_error);
      }
    },
    methods: {
      ...mapActions({
        sendToPDF: 'printer/sendToPDF',
        sendToExcel: 'printer/sendToExcel',
      }),

      generarPDF() {
        this.sendToPDF({ active: true });
      },
      generarExcel() {
        this.itemCSV = [
          this.createRow({
            C1: 'Datos del Cliente',
          }),

          this.createRow({
            C1: 'Nombre del Cliente',
            C2: 'RFC',
            C3: 'Número del Cliente',
          }),

          this.createRow({
            C1: this.dataClient.NAME1,
            C2: this.dataClient.STCD1,
            C3: this.dataClient.KUNNR,
          }),

          this.createRow(),

          this.createRow({
            C1: 'Cartera y Línea de crédito',
          }),

          this.createRow({
            C1: 'Límite de crédito',
            C2: 'Línea de crédito comprometida',
            C3: 'Línea de crédito disponible',
            C4: 'Plazo en días',
            C5: 'Saldo Vencido',
            C6: 'Saldo Total',
            C7: 'Notas de Crédito por aplicar',
            C8: 'Documentos pendientes por aplicar',
          }),

          this.createRow({
            C1: this.dataClient.KLIMK,
            C2: `$${this.dataClient.SKFOR}`,
            C3: `$${this.dataClient.CREDD}`,
            C4: this.dataClient.VTEXT,
            C5: `$${this.dataClient.SVENC}`,
            C6: `$${this.dataClient.STOTA}`,
            C7: `$${this.dataClient.NCPA}`,
            C8: `$${this.dataClient.PPPA}`,
          }),

          this.createRow(),

          this.createRow({
            C1: `Movimientos al ${this.dateCurrent}`,
          }),

          this.createRow({
            C1: 'Factura',
            C2: 'Orden de Compra',
            C3: 'Fecha Factura',
            C4: 'Fecha Entrega',
            C5: 'Fecha Vencimiento',
            C6: 'Días Vencidos',
            C7: 'Estatus',
            C8: 'Importe Factura aqui',
            C9: 'Nota de Crédito',
            C10: 'Importe Nota de Crédito',
            C11: 'Pago',
            C12: 'Importe Pago',
            C13: 'DPP',
            C14: '% DPP',
            C15: 'Neto a Pagar',
          }),

          ...this.dataMovemets.map((item) =>
            this.createRow({
              C1: item.number,
              C2: item.orderName,
              C3: item.invoiceDate,
              C4: item.date,
              C5: item.expiration,
              C6: item.days,
              C7: item.status,
              C8: this.formatNumber(item.amount),
              C9: item.vbelnnc,
              C10: this.formatNumber(item.dmbtrnc),
              C11: item.belnrdz,
              C12: this.formatNumber(item.dmbtrdz),
              C13: `$${item.difbudat}`,
              C14: `%${item.difbudatp}`,
              C15: this.formatNumber(item.impfacnet),
            })
          ),
        ];

        this.sendToExcel({ items: this.itemCSV });
      },
      createRow(columns = {}) {
        const row = {};

        for (let i = 1; i <= 15; i++) {
          row[`C${i}`] = columns[`C${i}`] ?? '';
        }

        return row;
      },
      async getDataClient() {
        try {
          let response = await axios.post('grupo-cliente/data-client', {
            client: this.customerCode,
            VKORG: this.user.VKORG,
            VTWEG: this.user.VTWEG,
            VKBUR: this.user.VKBUR,
            P_OPCGPO: 0,
          });
          this.dataClient = response.data.dataDetailClient;
          this.loader = false;
        } catch (error) {
          this.loader = false;
        }
      },
      validateSelectedInvoice() {
        if (this.invoiceStatus) {
          this.$swal({
            title:
              'Usted tiene facturas vencidas, no puede obtener el beneficio del descuento hasta que liquide las facturas vencidas',
            icon: 'error',
            type: 'danger',
            confirmButtonText: 'CONTINUAR',
            confirmButtonColor: '#A82222',
            closeOnConfirm: true,
          });
        }
        if (this.invoice.length > 1) {
          this.$swal({
            title: 'No se puede seleccionar mas de una factura',
            icon: 'error',
            type: 'danger',
            confirmButtonText: 'CONTINUAR',
            confirmButtonColor: '#A82222',
            closeOnConfirm: true,
          });
        }
      },
      async getBonds() {
        const response = await axios.get(
          '/get-bonds/' + this.customerCode + '/' + this.user.VTWEG
        );
        if (response.data.result == 1) {
          if (response.data.data.length == 0) {
            this.bonoShow = false; // no tienes bonos o hay facturas vencidas
          } else {
            this.bonoShow = true;
            this.bonds = response.data.data;
          }
        }
      },
      async getCustomerInformation() {
        const params = {
          client: this.customerCode,
          channel: this.user.VTWEG,
        };

        const response = await axios.post('/getExpiredOrders', params);
        this.dataMovemets = response.data;
      },
      toPay() {
        this.selected;
        this.typePay = 1;
        this.dialog = true;
      },
      bondCard() {
        if (this.bondCurrent == '262') {
          this.toBond();
        } else if (this.bondCurrent === '2RC') {
          this.showBondsModal = true;
        }
      },
      toBond() {
        this.loadingBono = true;
        this.isSubmitted = true;
        const bondAmount = this.unformatNumber(
          this.bonds.find((b) => b.id == this.bondCurrent).cost
        );
        const bondCost = this.bondCost == 0 ? bondAmount : this.bondCost;
        const amountToPay = this.bondCurrent == '2RC' ? bondCost : bondAmount;
        const selectedBonus = this.invoice.some((item) => item.auart === 'PSPP')
          ? '2PP'
          : this.bondCurrent;

        axios
          .post('note-credit', {
            client_code: this.customerCode,
            invoice: this.invoice,
            code: selectedBonus,
            cost: amountToPay,
            channel: this.user.VTWEG,
          })
          .then((response) => {
            this.loadingBono = false;
            if (response.data.result == 1) {
              this.$swal({
                html: `<b>${response.data.message}</b>`,
                icon: 'success',
                type: 'succes',
                confirmButtonText: 'CONTINUAR',
                confirmButtonColor: '#A82222',
                closeOnConfirm: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload();
                }
              });

              this.isSubmitted = false;
              this.showBondsModal = false;
            } else {
              this.$swal({
                title: response.data.data,
                icon: 'error',
                type: 'danger',
                confirmButtonText: 'CONTINUAR',
                confirmButtonColor: '#A82222',
                closeOnConfirm: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });

              this.isSubmitted = false;
              this.showBondsModal = false;
            }
          });
      },
      toAntPay() {
        this.selected;
        this.typePay = 2;
        this.dialog = true;
      },
      videoShow() {
        this.dialogVideo = true;
      },
      close() {
        this.dialog = false;
        this.bank = null;
      },

      closeModalVideo() {
        this.dialogVideo = false;
      },
      format(value) {
        const result = Number(value).toFixed(2);
        return result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      getParam1() {
        let token = this.$route.query.token;
        let type_bank = this.user.VTWEG == 'PR' ? 11 : 1;
        this.sendToken(token, type_bank);
      },
      getParam2(params1, params2, params3) {
        this.$swal({
          title: params1,
          text: params2 + ' ' + params3,
          icon: params1 == 'Rechazado' ? 'warning' : 'success',
          type: params1 == 'Rechazado' ? 'warning' : 'success',
        }).then((result) => {
          if (result.value) {
            this.$router.replace({ query: null });
            location.reload();
          }
        });
      },
      getParam3() {
        let token = this.$route.query.strResponse;
        let type_bank = 3;
        this.sendToken(token, type_bank);
      },
      sendToken(token, bank) {
        if (token.length != 0) {
          axios
            .post('getToken', {
              token: token,
              bank: bank,
              customer: this.customerCode,
            })
            .then((response) => {
              this.$swal({
                title: response.data.FNMSG,
                icon: 'success',
                type: 'succes',
              }).then((result) => {
                if (result.value) {
                  this.$router.replace({ query: null });
                  location.reload();
                }
              });
            })
            .catch((error) => {
              if (error.response.data.errors) {
                this.msg = error.response.data.errors;
                this.hasError = true;
                this.snackbar = true;
                setTimeout(() => {
                  this.hasError = false;
                }, 8000);
              }
            });
        }
      },
      setBondPaymentAmount(value) {
        this.bondCost = value;
      },
      disabledButtonBond(value) {
        this.isSubmitted = value;
      },
      async downloadPdfReport() {
        this.downloading = true;

        const addres = `${this.dataClient.STREET} N° ${this.dataClient.HOUSE_NUM1}, ${this.dataClient.CITY2}. CP. ${this.dataClient.POST_CODE1}`;
        const lastPpdp = `${this.dataClient.PPDP} (${this.dataClient.DOCDP})`;

        const params = {
          client: this.customerCode,
          channel: this.user.VTWEG,
          customerData: {
            name: this.dataClient.NAME1,
            rfc: this.dataClient.STCD1,
            number: this.formatCustomer(this.dataClient.KUNNR),
            addres: addres,
          },
          creditData: {
            creditLimit: this.dataClient.KLIMK,
            committedCredit: this.dataClient.SKFOR,
            availableCredit: this.dataClient.CREDD,
            termDays: this.dataClient.VTEXT,
            overdueBalance: this.dataClient.SVENC,
            totalBalance: this.dataClient.STOTA,
            creditNotes: this.dataClient.NCPA,
            pendingDocs: this.dataClient.PPPA,
            lastPpdp: lastPpdp,
          },
        };

        try {
          const response = await axios.post('/account-movements/pdf', params, {
            responseType: 'blob',
          });
          this.saveFileToDevice(response.data, 'movimientos_cuenta', 'pdf');
        } catch (error) {
          this.$toast.error('No fue posible completar la descarga.');
        }

        this.downloading = false;
      },
      formatCustomer(value) {
        return this.$options.filters.formatCustomer(value);
      },
    },
  };
</script>
<style scoped src="../../assets/css/accountmove.css"></style>
<style scope>
  .notice-container {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  #container .v-btn .v-btn__content {
    white-space: normal !important;
    min-width: 20 !important;
    width: 100% !important;
    height: 40px !important;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  #container .v-row {
    flex-wrap: wrap !important;
  }

  #container .text-wrap {
    white-space: normal;
    text-align: center;
  }
</style>
